import type { PresentationIsEmptyProps } from '../../'
export default function isEmpty({ quote }: PresentationIsEmptyProps) {
  const hasContent = quote?.terms?.content && quote.terms.content.replace('<p></p>', '').trim()
  return !hasContent
}
